"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconTurbineGenerator = function IconTurbineGenerator(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M33 5v6h5.487l2.177 20h.961l.735 6H39v6H9v-6H5.505l.6-6h1.277l1.825-20H16V5zm-2 2v4H18V7zM7.715 35H40.1l-.245-2H7.915zM11 37v4h26v-4zm25.692-24 1.96 18H9.392l1.641-18zM25 29V15h-1v14zm3.958-13.37 1 12.67-.996.08-1-12.67zm6.536 12.632-2-12.67-.988.156 2 12.67zM19.202 15.631l.996.078-1 12.67-.997-.078zm-3.558.117-.988-.156-2 12.67.988.156z",
    clipRule: "evenodd"
  })));
};

export { IconTurbineGenerator, IconTurbineGenerator as default };
